import urlParse from 'url-parse';

const getHostName = (source: string): string => {
  return urlParse(source).hostname;
};

export { getHostName };
